import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

import { Loader } from '@/components/loader'
import { OauthCallback } from '@/pages/auth/oauth-callback'

import { runOAuthCallbackLoader } from './-loader-logic'

const oauthCallbackSchema = z.object({
  code: z.string().optional(),
  state: z.string().optional(),
})

const defaultOAuthCallbackQuery = {
  code: undefined,
  state: undefined,
}

export const Route = createFileRoute('/_auth/login/oauth/')({
  pendingComponent: Loader,
  component: OauthCallback,
  validateSearch: (search) => oauthCallbackSchema.catch(defaultOAuthCallbackQuery).parse(search),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ deps: { search } }) => runOAuthCallbackLoader(search),
})
